import { render, staticRenderFns } from "./wallets.vue?vue&type=template&id=6345c4ea&"
import script from "./wallets.vue?vue&type=script&lang=ts&"
export * from "./wallets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports